module.exports = __webpack_public_path__ + "static/media/OOLogo.cb33f75e.svg";